import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth, homeFor } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Riders from "@/pages/Riders";
import RiderLedger from "@/pages/RiderLedger";
import Onboarding from "@/pages/Onboarding";
import Vehicles from "@/pages/Vehicles";
import Batteries from "@/pages/Batteries";
import Invoices from "@/pages/Invoices";
import SwapHistory from "@/pages/SwapHistory";
import Employees from "@/pages/Employees";
import BatterySwap from "@/pages/BatterySwap";

const Loader = () => (
  <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center">
    <div className="h-8 w-8 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
  </div>
);

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return <Layout>{children}</Layout>;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return <Navigate to={user ? homeFor(user.role) : "/login"} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/dashboard" element={<Guard roles={["admin"]}><Dashboard /></Guard>} />
          <Route path="/riders" element={<Guard roles={["admin", "ops"]}><Riders /></Guard>} />
          <Route path="/riders/:riderId" element={<Guard roles={["admin", "ops"]}><RiderLedger /></Guard>} />
          <Route path="/onboarding" element={<Guard roles={["admin", "ops"]}><Onboarding /></Guard>} />
          <Route path="/vehicles" element={<Guard roles={["admin"]}><Vehicles /></Guard>} />
          <Route path="/batteries" element={<Guard roles={["admin"]}><Batteries /></Guard>} />
          <Route path="/invoices" element={<Guard roles={["admin"]}><Invoices /></Guard>} />
          <Route path="/swap-history" element={<Guard roles={["admin"]}><SwapHistory /></Guard>} />
          <Route path="/employees" element={<Guard roles={["admin"]}><Employees /></Guard>} />
          <Route path="/swap" element={<Guard roles={["incharge", "admin"]}><BatterySwap /></Guard>} />
          <Route path="*" element={<HomeRedirect />} />
        </Routes>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
